module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-translation row column"
  }, [_c('GroupedTranslation', {
    attrs: {
      "translations": _vm.overridenTranslations
    }
  }, [_c('h3', [_vm._v("Overriden translations")])]), _c('GroupedTranslation', {
    attrs: {
      "translations": _vm.errorMessages
    }
  }, [_c('h3', [_vm._v("Overridable translations")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68e363f2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/TranslationList.vue
// module id = 2407
// module chunks = 1